//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "transferOrder-popup-view",
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        workOrderId: {
            type: Number,
            required: true,
        },
        organizationId: {
            type: Number,
            required: true,
        },
        dutyParty: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            transferOrderDto: {},
            saving: false,
            weiBaoUsers: [],
            showWeiBaoUserPopup: false
        }
    },
    computed: {},
    methods: {
        cancel() {
            this.transferOrderDto = {}
            this.$emit('cancel', false)
        },
        onSave() {
            this.transferOrderDto.workOrderId = this.workOrderId;
            this.saving = true;
            abp.ajax.post('api/services/app/WorkOrder/MSaveTransferOrder', this.transferOrderDto).then(res => {
                this.cancel();
                this.$emit('save')
            }).finally(() => {
                this.saving = false
            })
        },
        geWeiBaoUser() {
            if (this.organizationId <= 0) {
                return
            }
            const vm = this;
            abp.ajax.get('api/services/app/OrganizationUnit/GetWeiBaoUsers?organizationId=' + vm.organizationId).then(res => {
                vm.weiBaoUsers = [];
                vm.weiBaoUsers.push(...res.data.result)
                vm.weiBaoUsers.forEach(item => {
                    item.text = item.name;
                })
            }).finally(() => {

            });

        },
        geWuYeUser() {
            if (this.organizationId <= 0) {
                return
            }
            const vm = this;
            abp.ajax.get('api/services/app/OrganizationUnit/GetWuYeUsers?organizationId=' + vm.organizationId).then(res => {
                vm.weiBaoUsers = [];
                vm.weiBaoUsers.push(...res.data.result)
                vm.weiBaoUsers.forEach(item => {
                    item.text = item.name;
                })
            }).finally(() => {

            });
        },
        weiBaoUserConfirm(data) {
            this.transferOrderDto.dutyPerson = data.id
            this.transferOrderDto.dutyPersonName = data.name
            this.showWeiBaoUserPopup = false
        },
        showWeiBao() {
            if (this.dutyParty === 1) {
                this.geWeiBaoUser();
            } else if (this.dutyParty === 2) {
                this.geWuYeUser();
            }
            this.showWeiBaoUserPopup = true;
        }
    },
    created() {
    }
}
